
import Vue from "vue";
import { Company } from "@/models/company";
import { Subscription } from "@/models/subscription";
import { SubscriptionSerivce } from "@/services/subscription-service";
import AppCompanyPlan from "./CompanyPlan.vue";
import AppSubscriptionEdit from "./CompanySubscriptionEdit.vue";
import AppCompanyEditWrapper from "./CompanyEditWrapper.vue";

export default Vue.extend({
	data(){
		return {
			subscriptions: [] as Subscription[],
			shownSubscription: null as Subscription | null,
			toEditSub: null as Subscription | null,
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	methods: {
		showPlan(subscription:Subscription){
			this.shownSubscription = subscription;
		},
		async cancelSub(subscription:Subscription){
			let confirm = await this.$wf.confirm("Are you sure you want to cancel this subscription?", "yes", "no", "WARNING", "warning");
			if (!confirm){
				return;
			}
			await SubscriptionSerivce.cancelSubscription(this.company.id, subscription.id);
			this.fetchSubs();
		},
		async fetchSubs(){
			this.subscriptions = await SubscriptionSerivce.getSubscriptions(this.company.id);
		},
		async editSub(sub:Subscription){
			this.toEditSub = await SubscriptionSerivce.getSubscription(this.company.id, sub.id);
		},
		onEditSubClose(){
			this.toEditSub = null;
			this.fetchSubs();
		}
	},
	async created(){
		this.fetchSubs();
	},
	components: {
		AppCompanyPlan,
		AppSubscriptionEdit,
		AppCompanyEditWrapper
	}
});
